export default __webpack_public_path__ + "static/media/CaretRight.717be6d5.svg";